var CertExtensions_1;
import { __decorate } from "tslib";
import { Extensions } from "@peculiar/asn1-x509";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
export const id_certExtensions = "1.3.6.1.4.1.311.2.1.14";
let CertExtensions = CertExtensions_1 = class CertExtensions extends Extensions {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CertExtensions_1.prototype);
    }
};
CertExtensions = CertExtensions_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], CertExtensions);
export { CertExtensions };
